// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__1BSt-","wide":"Tag_wide__eATHI","fullWidth":"Tag_fullWidth__RIZad"};